import React from "react";

const LoadingProduct = () => {
    return (
      <input
        style={{ marginTop: '30px', cursor:'default' }}
        type='submit'
        value={'Loading ...'}
        disabled
      />
    );
};

export default LoadingProduct;